import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const UserProfileMenu = ({ language, direction, isCollapsed = false }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const userRole = 'lawyer';
  const userName = 'Ahmed Benali';
  const userEmail = 'ahmed.benali@legaloffice.ma';

  const menuItems = [
    {
      id: 'profile',
      labelEn: 'Profile Settings',
      labelFr: 'Paramètres du profil',
      labelAr: 'إعدادات الملف الشخصي',
      icon: 'User',
      action: () => console.log('Profile settings')
    },
    {
      id: 'preferences',
      labelEn: 'Preferences',
      labelFr: 'Préférences',
      labelAr: 'التفضيلات',
      icon: 'Settings',
      action: () => console.log('Preferences')
    },
    {
      id: 'help',
      labelEn: 'Help & Support',
      labelFr: 'Aide et support',
      labelAr: 'المساعدة والدعم',
      icon: 'HelpCircle',
      action: () => console.log('Help')
    },
    {
      id: 'logout',
      labelEn: 'Logout',
      labelFr: 'Déconnexion',
      labelAr: 'تسجيل الخروج',
      icon: 'LogOut',
      action: () => navigate('/login')
    }
  ];

  const getLabel = (item) => {
    if (language === 'fr') return item?.labelFr;
    if (language === 'ar') return item?.labelAr;
    return item?.labelEn;
  };

  const getRoleLabel = () => {
    if (language === 'fr') {
      return userRole === 'lawyer' ? 'Avocat' : userRole === 'secretary' ? 'Secrétaire' : 'Administrateur';
    }
    if (language === 'ar') {
      return userRole === 'lawyer' ? 'محامي' : userRole === 'secretary' ? 'سكرتير' : 'مدير';
    }
    return userRole?.charAt(0)?.toUpperCase() + userRole?.slice(1);
  };

  const getInitials = (name) => {
    return name?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2);
  };

  if (isCollapsed) {
    return (
      <div className="user-profile-menu">
        <button
          className="user-profile-trigger justify-center px-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="User menu"
        >
          <div className="user-profile-avatar text-sm">
            {getInitials(userName)}
          </div>
        </button>
        {isOpen && (
          <>
            <div
              className="fixed inset-0 z-[90]"
              onClick={() => setIsOpen(false)}
            />
            <div className="user-profile-dropdown" style={{ direction }}>
              <div className="px-4 py-3 border-b border-border">
                <div className="flex items-center gap-3">
                  <div className="user-profile-avatar text-sm">
                    {getInitials(userName)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-foreground truncate">
                      {userName}
                    </p>
                    <p className="text-xs text-muted-foreground truncate">
                      {getRoleLabel()}
                    </p>
                  </div>
                </div>
              </div>

              {menuItems?.map((item) => (
                <button
                  key={item?.id}
                  className="user-profile-dropdown-item w-full text-left"
                  onClick={() => {
                    item?.action();
                    setIsOpen(false);
                  }}
                >
                  <Icon name={item?.icon} size={18} />
                  <span className="text-sm">{getLabel(item)}</span>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="user-profile-menu">
      <button
        className="user-profile-trigger w-full"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="user-profile-avatar">
          {getInitials(userName)}
        </div>
        <div className="flex-1 min-w-0 text-left">
          <p className="text-sm font-semibold text-foreground truncate">
            {userName}
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {getRoleLabel()}
          </p>
        </div>
        <Icon
          name={isOpen ? 'ChevronDown' : 'ChevronUp'}
          size={18}
          className="text-muted-foreground"
        />
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[90]"
            onClick={() => setIsOpen(false)}
          />
          <div className="user-profile-dropdown" style={{ direction }}>
            <div className="px-4 py-3 border-b border-border">
              <p className="text-xs text-muted-foreground truncate">
                {userEmail}
              </p>
            </div>

            {menuItems?.map((item) => (
              <button
                key={item?.id}
                className="user-profile-dropdown-item w-full text-left"
                onClick={() => {
                  item?.action();
                  setIsOpen(false);
                }}
              >
                <Icon name={item?.icon} size={18} />
                <span className="text-sm">{getLabel(item)}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfileMenu;